import React from 'react';
import { Box, TextBody } from '@ally/metronome-ui';
export default function LastLoginTime({ focusRef, lastLoginTime, }) {
    if (!lastLoginTime) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Box, null,
        React.createElement(TextBody, { tag: "div", size: "sm", id: "profile-menu-last-login", ref: focusRef, tabIndex: -1 },
            "Last Login: ",
            lastLoginTime)));
}
//# sourceMappingURL=LastLoginTime.js.map